import React from "react";
import { getFileIcon } from "../../services/question";
import { getFileTarget } from "../../services/api/file_upload";

// The thumbnail (or file-type icon) for an answer's files, with a "(+N)" badge
// when there is more than one.
//
// 2026-10-23: this lived in pages/jobs/components/editor_v2 and was imported
// from there by components/answer/question_summary — which editor_v2 itself
// imports. That cycle meant every chunk holding the question renderer (the
// create wizards, the settings screens, the dashboard) also held the whole
// 900 KB job editor, for a 40-line helper that needs nothing from it.
export const renderIcon = (files, fileInfo) => {
  const filteredFiles = files.filter((file) => file !== null);
  if (
    !filteredFiles[0] ||
    filteredFiles[0].length === 0 ||
    (fileInfo && Object.keys(fileInfo).length === 0)
  ) {
    return "";
  }

  if (!fileInfo || !fileInfo[filteredFiles[0]]) {
    return "";
  }
  const extension = fileInfo[filteredFiles[0]].extension;
  const icon = getFileIcon(extension);
  const file = filteredFiles[0];
  if (icon.includes("-image") && file) {
    return (
      <div>
        <img src={getFileTarget(file, "100x100")} alt={file.Name} />{" "}
        {filteredFiles.length > 1 && (
          <span className="image-files-length">
            ({filteredFiles.length - 1})
          </span>
        )}
      </div>
    );
  }
  return (
    <div>
      <i className={icon} />
      {filteredFiles.length > 1 && (
        <span className="image-files-length">({filteredFiles.length - 1})</span>
      )}
    </div>
  );
};

export default renderIcon;
